import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  insightsContent: {
    paddingBottom: '5rem',
  },
  table: {
    width: 'max(100%, 105rem)',
  },
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    marginBottom: '5rem',
    overflow: 'hidden',
  },
  tableBody: {
    height: '36rem',
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    padding: '1.6rem 0rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  dateInput: {
    '&:first-child': {
      marginRight: '3rem',
    },
  },
  groupsCountText: {
    textAlign: 'right',
    font: {
      size: '1.6rem',
    },
    lineHeight: '1.8rem',
    marginBottom: '2rem',
  },
  groupsCount: {
    marginLeft: '1rem',
  },
  infoWrapper: {
    display: 'flex',
    marginBottom: '5rem',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
